/*!
 * Copyright (C) 2019-2022, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 *		2022-06-23
 *			- view-room-details.store.js now sends API requests to port 4321 on SUGAR.
 *			- Add showingPreferredOffer getter in view-room-details.store.js.
 *
 *		2022-06-23
 *			- view-room-details.store.js now has checkInDate, checkOutDate, updateCheckInDate() and updateCheckOutDate() to be compatible with hotel-room.store.js.
 *
 *		2022-06-23
 *			- Add ROOM_BED_VARIANT to output of currentRoomTypeTitleData() in view-room-details.store.js.
 */
//@ts-ignore
import Vue from 'vue/dist/vue.esm'
import Vuex from "vuex";
import {
  HotelBookingLinkData, RoomAvailabilityData, RoomAvailabilityRoomType,
  ViewRoomDetailsHotelRoomData,
  ViewRoomDetailsRoomDisplayData
} from "../components/hotel/defs";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentPrtId: 0,
    roomData: [] as ViewRoomDetailsHotelRoomData[],
    bookingLinkData: {} as HotelBookingLinkData,
    defaultDisplayData: {} as ViewRoomDetailsRoomDisplayData,
    currentRoomTitle: '',
    bookingLink: '#',

    currentSubtotal: '',
    currentStateTax: '',
    currentTax: '',
    currentTourismSurcharge: '',
    currentResortFee: '',
    currentResortFeeTax: '',
    currentTotal: '',

    resortFeeSubtotal: 0,
    resortFeeTax: 0,
    useResortFee: true,

    strikeThroughStateTax: 0,
    strikeThroughSubtotal: 0,
    strikeThroughTotal: 0,


    tooltipResortFee: '',
    tooltipTourismSurcharge: '$2 per night',
    tooltipTotal: '',


    showSimilarRooms: false,
    similarRoomTowerOmit: '',

    bookingLinkUpdateTimer: null,

    allowedOfferCodesForPreferred: ['', '*TUSCANY', '*PEPTOWER', '*NORTHWEST', '*ADA', 'PREFERRED'],
    preferredUserIsLoggedIn: false,
    showPreferredOnboardingForm: false,
    preferredOfferCode: 'PREFERRED',

    adultMin: 1,
    adultMax: 4,
    childMin: 0,
    childMax: 2,

    bookingDisabled: false,

    isDevEnvironment: ('dev.peppermillreno.com' === location.hostname),

    apiUrl: 'https://reserve1.peppermillcas.com:4321/resnet-api/index.php',

    calendarLoaded: false,
    calendarOpen: false,

    metaClick: false,

    //compatability with hotel filter component for calendar
    checkInDate: null as Date | null,
    checkOutDate: null as Date | null,

    isVariantDialogVisible: false,
  },
  mutations: {
    currentPrtId: (state, newPrtId) => {
      state.currentPrtId = parseInt(newPrtId, 10);
    },
    // roomData: (state, data) => {
    //     state.roomData = data;
    // },
    // bookingLinkData: (state, data) => {
    //     state.bookingLinkData = data;
    // },
    // defaultDisplayData: (state, data) => {
    //     state.defaultDisplayData = data;
    // },
    // preferredOfferCode: (state, newOfferCode) => {
    //     state.preferredOfferCode = newOfferCode;
    // },
    updateState: (state, data: [string, any]) => {
      // pepConsole.log('updateState', data);
      if (data.length === 2 && data[0] in state) {
        //@ts-ignore
        state[data[0]] = data[1];
      }
    },
    updateOfferCode: (state, newOfferCode) => {
      state.bookingLinkData.offerCode = newOfferCode;
    },
    updateRoomSequenceNumber: (state, newSequenceNumber) => {
      state.bookingLinkData.roomNum = newSequenceNumber;
    },
    updateLmsReference: (state, newReferenceCode) => {
      state.bookingLinkData.lmsRef = newReferenceCode;
    },

    incrementAdults: state => {
      if (state.bookingLinkData.adults < state.adultMax) {
        state.bookingLinkData.adults++;
      }
    },
    decrementAdults: state => {
      if (state.bookingLinkData.adults > state.adultMin) {
        state.bookingLinkData.adults--;
      }
    },
    incrementChildren: state => {
      if (state.bookingLinkData.children < state.childMax) {
        state.bookingLinkData.children++;
      }
    },
    decrementChildren: state => {
      if (state.bookingLinkData.children > state.childMin) {
        state.bookingLinkData.children--;
      }
    },
    updateCheckInDate: (state, checkInDate) => {
      state.bookingLinkData.start = checkInDate;
      if ('string' === typeof checkInDate) {
        const parts = checkInDate.split('-');
        checkInDate = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
      }
      state.checkInDate = checkInDate;
    },
    updateCheckOutDate: (state, checkOutDate) => {
      state.bookingLinkData.end = checkOutDate;
      if ('string' === typeof checkOutDate) {
        const parts = checkOutDate.split('-');
        checkOutDate = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
      }
      state.checkOutDate = checkOutDate;
    }
  },
  getters: {
    currentRoomType: state => {
      if (state.currentPrtId > 0) {
        for (let i = 0, l = state.roomData.length; i < l; i++) {
          if (state.roomData[i].PRT_ID === state.currentPrtId) {
            return state.roomData[i];
          }
        }
      }
      //fallback
      if (state.roomData.length > 0) {
        return state.roomData[0];
      }

      return false;
    },
    currentRoomWingCode: (state, getters) => {
      const currentRoomType = getters.currentRoomType;
      if (currentRoomType && 'DATA' in currentRoomType && currentRoomType.DATA.length && 'rrcsn_wing_code' in currentRoomType.DATA[0]) {
        return currentRoomType.DATA[0].rrcsn_wing_code;
      }
      return '';
    },
    currentRoomTitle: (state, getters) => {
      const currentRoomType = getters.currentRoomType;
      if (currentRoomType && 'DISPLAY' in currentRoomType && 'ROOM_TITLE' in currentRoomType.DISPLAY) {
        return currentRoomType.DISPLAY.ROOM_TITLE;
      }
      return '';
    },
    currentAdults: (state) => {
      if (state.bookingLinkData.hasOwnProperty('adults') && 0 < state.bookingLinkData.adults && 5 > state.bookingLinkData.adults) {
        return state.bookingLinkData.adults;
      }
      //default
      return 2;
    },
    currentPreferredSubtotal: (state, getters) => {
      if (getters.currentRoomType && getters.currentRoomType.hasOwnProperty('DISPLAY') && getters.currentRoomType.DISPLAY.hasOwnProperty('PREFERRED_SUBTOTAL')) {
        return getters.currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[getters.currentAdults] || 0;
      }
      //default
      return 0;
    },
    currentPreferredRoomSequenceNumber: (state, getters) => {
      if (getters.currentRoomType && getters.currentRoomType.hasOwnProperty('DISPLAY') && getters.currentRoomType.DISPLAY.hasOwnProperty('PREFERRED_ROOM_NUM')) {
        return getters.currentRoomType.DISPLAY.PREFERRED_ROOM_NUM;
      }
      //default
      return 0;
    },


    bookingLinkStartDate: state => {
      return state.bookingLinkData.start || '';
    },
    bookingLinkEndDate: state => {
      return state.bookingLinkData.end || '';
    },
    bookingLinkRoomPageId: state => {
      if (state.bookingLinkData.room_page_id) {
        return state.bookingLinkData.room_page_id;
      } else if (state.bookingLinkData.extraData?.room_page_id) {
        return state.bookingLinkData.extraData.room_page_id;
      }
      return 0;
    },

    apiUrl: state => {
      if (state.isDevEnvironment) {
        return state.apiUrl + (-1 === state.apiUrl.indexOf('?') ? '?' : '&') + 'TEST=YES';
      }
      return state.apiUrl;
    },

    showingPreferredOffer: function (state, getters) {
      const currentRoomType = getters.currentRoomType;
      const correctCurrentOfferCode = (-1 !== state.allowedOfferCodesForPreferred.indexOf(state.bookingLinkData.offerCode || ''));
      const currentRoomTypeHasPreferred = (currentRoomType && 'DISPLAY' in currentRoomType && 0 < currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[state.bookingLinkData.adults]);

      return correctCurrentOfferCode && currentRoomTypeHasPreferred;
    },

    selectedDates: (state): string[] => {
      const output = [];
      if (state.checkInDate && state.checkOutDate) {
        let currentDate = state.checkInDate;
        const checkOutTime = state.checkOutDate?.getTime() || 0;
        while ((currentDate?.getTime() || 0) <= checkOutTime) {
          output.push(window.pepDateFunctions.formatDateObjectYYYYMMDD(currentDate));
          currentDate = window.pepDateFunctions.addDays(currentDate, 1);
        }
      } else if (state.checkInDate) {
        output.push(window.pepDateFunctions.formatDateObjectYYYYMMDD(state.checkInDate));
      } else if (state.checkOutDate) {
        output.push(window.pepDateFunctions.formatDateObjectYYYYMMDD(state.checkOutDate));
      }

      return output;
    },

    bookingLink: (state, getters) => (roomData: ViewRoomDetailsHotelRoomData, prtId = 0, offerCode = '', pageId = 0, clickSource = 'hotel-widget'): string => {
      const params: {
        room_page_id: number,
        clickSource: string,
        o: string,
        start?: string,
        end?: string,
        test?: number,
        auto_book_prt?: number,
        room?: number
      } = {
        room_page_id: pageId,
        clickSource,
        o: offerCode,
        auto_book_prt: prtId,
        room: roomData.DATA[0]?.rrcd_sequence_number || 0,
        test: (/[&?]test=1$/.test(location.href)) ? 1 : undefined
      };

      if (state.checkInDate) {
        params.start = window.pepDateFunctions.formatDateObjectYYYYMMDD(state.checkInDate);
      }
      if (state.checkOutDate) {
        params.end = window.pepDateFunctions.formatDateObjectYYYYMMDD(state.checkOutDate);
      }

      return '/choose-a-room/?' + $.param(params);
    },

    roomTypeIsAvailable: (state, getters) => (roomData: ViewRoomDetailsHotelRoomData): boolean => {
      const stayLength = getters.stayLength;
      return (roomData.DATA[0]?.rrcd_min_stay_days || 0) <= stayLength;
    },

    roomTypeTotalAvailable: (state, getters) => (roomData: ViewRoomDetailsHotelRoomData): number => {
      const stayLength = getters.stayLength;
      if (roomData.DATA[0]?.rrcd_min_stay_days > stayLength) {
        return roomData.DATA[0].rrcd_available_rooms;
      }

      return 0;
    },

    currentRoomTypeTitleData: (state, getters) => {
      const currentRoomType = getters.currentRoomType;
      if (currentRoomType) {
        let variantSmoking = '';

        if (true === currentRoomType.DISPLAY.ROOM_NON_SMOKING) variantSmoking = 'Non-Smoking';
        else if (true === currentRoomType.DISPLAY.ROOM_SMOKING) variantSmoking = 'Smoking';

        return {
          ROOM_TITLE: currentRoomType.DISPLAY.ROOM_TITLE,
          ROOM_SMOKING_VARIANT: variantSmoking,
          ROOM_BED_VARIANT: currentRoomType.DISPLAY.ROOM_BED_VARIANT,
          ROOM_ADA_VARIANT: currentRoomType.DISPLAY.ROOM_ADA_VARIANT,
          ROOM_ADA: currentRoomType.DISPLAY.ROOM_ADA,
          ROOM_NON_SMOKING: currentRoomType.DISPLAY.ROOM_NON_SMOKING,
          ROOM_SMOKING: currentRoomType.DISPLAY.ROOM_SMOKING,
          PRT_ID: currentRoomType.DISPLAY.PRT_ID
        };
      }

      return null;
    },
  }
});